module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-navbar', {
    attrs: {
      "type": "dark",
      "variant": "primary",
      "toggle-breakpoint": "md",
      "toggleable": ""
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "navbarSupportedContent",
      "aria-controls": "navbarSupportedContent",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Shadowtools")]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "navbarSupportedContent"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "mr-auto"
  }, [_c('b-nav-item', {
    attrs: {
      "to": "/modifiers"
    }
  }, [_vm._v("Dice Pool Modifiers")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "to": "/roller"
    }
  }, [_vm._v("Dice Roller")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "container"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f6afac4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 113
// module chunks = 2